import XCircleIcon from '@nv/images/design/x-circle-icon'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import VerificationInput from 'react-verification-input'
import { ErrorLabel } from '../error_label/ErrorLabel'
import styles from './AuthCodeInput.module.scss'

export const AuthCodeInput = ({
  code,
  setCode,
  length,
  codeError,
  authInputRef,
  errorMessage = 'auth.login.validations.invalidCodeTryAgain',
}: any) => {
  const { t } = useTranslation()

  return (
    <>
      <VerificationInput
        ref={authInputRef}
        autoFocus={true}
        inputProps={{ autoComplete: 'one-time-code' }}
        value={code}
        onChange={setCode}
        validChars='0-9'
        length={length}
        classNames={{
          container: styles['verify-input-container'],
          character: styles['verify-input'],
          characterSelected: clsx(styles['verify-input'], styles['verify-input--active']),
          characterInactive: clsx(styles['verify-input'], styles['verify-input--inactive']),
        }}
      />

      {codeError && (
        <div className={styles['invalid-code']}>
          <XCircleIcon className={styles['invalid-code__icon']} />
          <ErrorLabel label={t(errorMessage)} />
        </div>
      )}
    </>
  )
}
